import type React from 'react';
import IconButton from '../atoms/IconButton';

export interface ModalHeaderProps {
  title: string;
  subtitle?: string;
  onClose?: () => void;
  actions?: React.ReactNode;
  className?: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  subtitle,
  onClose,
  actions,
  className = ''
}) => (
    <div className={`flex items-center justify-between p-6 border-b border-border-light ${className}`}>
      <div className="flex-1 min-w-0">
        <h2 className="text-xl font-semibold text-text-primary truncate">
          {title}
        </h2>
        {subtitle && (
          <p className="text-text-muted text-sm mt-1">
            {subtitle}
          </p>
        )}
      </div>
      
      <div className="flex items-center space-x-2 ml-4">
        {actions}
        {onClose && (
          <IconButton
            onClick={onClose}
            variant="ghost"
            size="medium"
            title="Close"
            aria-label="Close"
            icon={
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            }
          />
        )}
      </div>
    </div>
  );

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;